module.exports = __webpack_public_path__ + "img/cupom.952fd0a9.svg";